// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1U61a","insightsList":"newBusinessInsightsMenu_insightsList__3pD33","active":"newBusinessInsightsMenu_active__2LbwA"};